import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import { formatDate } from '@/utils/func';
import { useDormitoryReport } from '@/hooks/app';
import { Flex, FoldingList, FoldingListItem, RetryAlert } from '@/components';
import { leaveStatusText } from '../helper';

const PAGE_SIZE = 10;

export default function LeaveReportMobile(props: ReturnType<typeof useDormitoryReport>) {

  const [t] = useTranslation(['common', 'dormitory']);
  const [page, _setPage] = useState(0);
  const fetchReport = useCallback(() => {
    props.fetch(page, PAGE_SIZE);
  }, [page]);

  const mappedItems: FoldingListItem[] = props.items.map(item => ({
    description: leaveStatusText(item.status, t),
    title: (
      <Flex className="w-full" inlineFlex>
        <Row className="w-full">
          <Col span={10}>{formatDate(item.fromDate, 'jYYYY/jMM/jDD')}</Col>
          <Col>
            <span className="text-xs text-dark/50">
              {item.relation}
            </span>
          </Col>
        </Row>
      </Flex>
    ),
    attrs: {
      id: { title: t('common:labels.id'), value: String(item.id) },
      relation: { title: t('dormitory:labels.relation'), value: item.relation },
      fromDate: { title: t('common:labels.start-date'), value: item.fromDate },
      toDate: { title: t('common:labels.end-date'), value: item.toDate },
      phoneNumber: { title: t('dormitory:labels.landline-phone'), value: item.phoneNumber },
      mobileNumber: { title: t('dormitory:labels.phone-number'), value: item.mobileNumber },
      address: { title: t('dormitory:labels.address'), value: item.address },
      description: { title: t('common:labels.description'), value: item.description },
    }
  } as FoldingListItem));

  useEffect(() => {
    fetchReport();
  }, [fetchReport]);

  return (
    props.error ?
      <RetryAlert noIcon action={fetchReport} content={props.error} /> :
      <FoldingList
        items={mappedItems}
        onEndReached={() => { }}
      />
  );
}
